import { useState, useEffect } from "react";

const MIN_WEBBUILDER_WIDTH = 1050;

export function useWebBuilderResolution() {
  const [isSupported, setIsSupported] = useState<boolean | undefined>(
    undefined,
  );
  const [isOverridden, setIsOverridden] = useState(false);

  useEffect(() => {
    const checkResolution = () => {
      setIsSupported(window.innerWidth >= MIN_WEBBUILDER_WIDTH);
    };

    const mql = window.matchMedia(`(min-width: ${MIN_WEBBUILDER_WIDTH}px)`);
    const onChange = () => {
      checkResolution();
    };

    mql.addEventListener("change", onChange);
    checkResolution();

    return () => mql.removeEventListener("change", onChange);
  }, []);

  const override = () => setIsOverridden(true);
  const reset = () => setIsOverridden(false);

  return {
    isSupported: isSupported === undefined ? true : isSupported || isOverridden,
    showWarning: isSupported === false && !isOverridden,
    override,
    reset,
    currentWidth: typeof window !== "undefined" ? window.innerWidth : 0,
    minWidth: MIN_WEBBUILDER_WIDTH,
  };
}
